import { useState } from "react";
import { Collection, Video } from "@/api";

export const useAppCTAModal = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalItem, setModalItem] = useState<Collection | Video | undefined>(
    undefined,
  );

  const openAppCTAModal = (item: Collection | Video) => {
    setModalItem(item);
    setModalOpen(true);
  };

  return {
    modalOpen,
    modalItem,
    openAppCTAModal,
    setModalOpen,
  };
};
